<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import realizarMedicionesAPI from "@/services/standards/realizarMediciones/realizarMedicionesAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "4.1.4 Realización de mediciones ambientales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
  },
  data() {
    return {
      title:
        "4.1.4 Realización de mediciones ambientales",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "4.1.4 Realización de mediciones ambientales",
        },
        {
          text: "Editar",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: "",

      file: null,

      medicion: {
        date: null,
        observations: null,
        copasst_information: null,
        file: null,
        types_measurements_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,

      lista: [],

      company: null,

      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading1: true,
      loading2: true,
      loading3: true,

      item: null,

      itemData: null,

      options: [
        {
          id: 1,
          description: "Iluminación",
        },
        {
          id: 2,
          description: "Sonometría",
        },
        {
          id: 3,
          description: "Dosimetría",
        },
        {
          id: 4,
          description: "Estrés térmico",
        },
        {
          id: 5,
          description: "Material particulado",
        },
        {
          id: 6,
          description: "Humos metálicos",
        },
        {
          id: 7,
          description: "Vibraciones",
        },
        {
          id: 8,
          description: "Sustancias químicas ",
        },
      ],
    };
  },
  validations: {
    file: {
      required,
    },
    medicion: {
      date: {
        required,
      },
      copasst_information: {
        required,
      },
      types_measurements_id: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(44)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.medicion.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/4.1.4/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/4.1.4/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.medicion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true
      this.loading1 = true
      let response = await this.uploadDocument();
      if (response) {
        realizarMedicionesAPI
          .update(this.$route.params.id, {
            companies_id: this.medicion.companies_id,
            date: this.medicion.date,
            observations: this.medicion.observations,
            copasst_information: this.medicion.copasst_information,
            file: this.medicion.file,
            types_measurements_id: this.medicion.types_measurements_id,
          })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 44,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  this.$router.go(-1);
                }, 2000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido actualizar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 2000)
      }
    },

    getList() {
      realizarMedicionesAPI
        .getList(this.companyID)
        .then((response) => {
          this.loading = false;
          this.lista = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getShow() {
      realizarMedicionesAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.medicion = {
            date: response.data.date,
            observations: response.data.observations,
            copasst_information: response.data.copasst_information,
            file: response.data.file,
            types_measurements_id: response.data.types_measurements_id,
            companies_id: response.data.companies_id,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 44)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    getMediciones() {
      realizarMedicionesAPI
        .get(this.companyID)
        .then((response) => {
          this.loading = false;
          this.list = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getShow();
    this.getData();
    this.getList();
    this.getItems();
    this.getItemData();
    this.getMediciones();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>
              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12 pt-2 px-2">
                  <b-form-group class="col-md-4 px-2" label="Tipos de mediciones" label-for="theme">
                    <b-form-select :disabled="!allowAccess() || !getRole('Crear')" id="theme"
                      v-model="medicion.types_measurements_id">
                      <b-form-select-option v-for="item in lista" :value="item.id" :key="item.id">
                        {{ item.name }}
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Fecha de la medición" label-for="input-sm">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="medicion.date" type="date"
                      id="input-sm" placeholder="fecha">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Subir informe de la medición" label-for="evidence">
                    <b-form-file :disabled="!allowAccess() || !getRole('Crear')" id="file" ref="file" name="file"
                      browse-text="Buscar"
                      :placeholder="medicion.file ? getFile(medicion.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="medicion.observations" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-row col-12">
                  <p class="col-md-4">
                    ¿Los resultados fueron informados al COPASST?
                  </p>
                  <b-form-group label="" v-slot="{ ariaDescribedby }" class="col-md-1 d-flex flex-row">
                    <b-form-radio :disabled="!getRole('Crear') || !allowAccess()" v-model="medicion.copasst_information"
                      :aria-describedby="ariaDescribedby" name="some-radios" value="SI">Si</b-form-radio>
                  </b-form-group>
                  <b-form-group label="" v-slot="{ ariaDescribedby }" class="col-md-1 d-flex flex-row">
                    <b-form-radio :disabled="!getRole('Crear') || !allowAccess()" v-model="medicion.copasst_information"
                      :aria-describedby="ariaDescribedby" name="some-radios" value="NO">No</b-form-radio>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
